export default "__VITE_ASSET__BuROOWkv__"